// Флаг, который указывает - инициализирован ли на странице скрипт для
// взаимодействия с VK Open API
var loaded = false; // Инициализирует интерфейс для взаимодействия с VK Open API, после инициализации
// взаимодействие осуществляется через глобальный объект `window.VK`

export default (function (apiId) {
  if (loaded) {
    return;
  }

  loaded = true;
  var initInterval = setInterval(function () {
    if (window) {
      window.S7tinkoff = {
        apiId: apiId,
        domain: 'https://id.tbank.ru',
        path: {
          auth: 'auth/authorize'
        }
      };
      clearInterval(initInterval);
    }
  }, 100);
});